import { CommonDateOnlyFormat } from 'helpers/common.helper';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { DateRangePicker } from 'react-date-range';
import { FaTimes } from 'react-icons/fa';
import { FaDownload } from 'react-icons/fa6';
import { ImSpinner2 } from 'react-icons/im';
import { IoIosArrowDropdown } from 'react-icons/io';
import ReactSelect from 'react-select';
import PermissionAllowed from './permissions/PermissionAllowed';
import { AnimatePresence, motion } from 'framer-motion';


const ExportListItemsModalMobile = ({
    openpopup,
    disablepopup,
    filters,
    moduleName,
    onSubmit,
    historyApi,
    isLoading,
    exportHistoryPerms
}) => {
    const [selectedValues, setSelectedValues] = useState({});
    const [exportsHistory, setExportsHistory] = useState([]);
    const [showHistory, setShowHistory] = useState(false);

    const handleFilterSelect = (name, value) => {
        if (value?.value == '' || value?.value == null) {
            setSelectedValues((oldVal) => {
                return { ...oldVal, [name]: undefined };
            });
        } else {
            setSelectedValues((oldVal) => ({ ...oldVal, [name]: value }));
        }
    };

    const handleSelectDate = (ranges) => {
        const rangesData = [ranges?.selection];
        setSelectedValues((oldData) => ({
            ...oldData,
            ...(rangesData?.[0]?.startDate
                ? { startDate: { value: moment(rangesData?.[0]?.startDate).startOf('day').format('YYYY-MM-DD HH:mm') } }
                : {}),
            ...(rangesData?.[0]?.endDate ? { endDate: { value: moment(rangesData?.[0]?.endDate).endOf('day').format('YYYY-MM-DD HH:mm') } } : {})
        }));
    };

    useEffect(() => {
        if (openpopup) loadExportHistory();
    }, [openpopup]);

    const loadExportHistory = () => {
        historyApi.then((res) => {
            res?.data && setExportsHistory(res?.data);
        });
    };

    const handleSubmit = () => {
        onSubmit(selectedValues);
    };

    if (!openpopup) return null;

    return (
			<div
				className="d-flex"
				style={{
					width: '100vw',
					height: '100dvh',
					position: 'fixed',
					left: 0,
					top: 0,
					zIndex: 20,
					background: 'rgba(0,0,0,0.07)',
					justifyContent: 'center',
					alignItems: 'end',
					paddingBottom: '90px',
					backdropFilter: 'blur(8px)',
					WebkitBackdropFilter: 'blur(8px)'
				}}
			>
				<div
					className="popup product-popup-mobile d-md-none"
					style={{
						position: 'relative',
						transform: 'none',
						top: 0,
						left: 0,
						maxWidth: '90%',
						background: '#fff',
						borderRadius: 12,
						boxShadow: 'rgb(0 0 0 / 37%) 0px 0px 20px',
						width: '100%',
						maxHeight: '70dvh',
						padding: '24px 16px 0 16px',
						display: 'flex',
						flexDirection: 'column'
					}}
				>
					{/* Header */}
					<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 12 }}>
						<h5 style={{ fontWeight: 600, fontSize: 18, margin: 0 }}>Export {moduleName ? `- ${moduleName}` : ''}</h5>
						<button className="btn modal-close-icon" onClick={disablepopup}>
							<FaTimes />
						</button>
					</div>

					{/* Filters */}
					<div style={{ flex: 'auto', overflowY: 'auto', marginBottom: 12 }}>
						{filters?.map((filter) =>
							filter?.name !== 'date_range' ? (
								<div className="form-group col-12" key={filter.name} style={{ marginBottom: 12 }}>
									<label htmlFor="" style={{ fontWeight: 500 }}>
										{filter.label}
									</label>
									<ReactSelect
										className="rs-filter-container"
										classNamePrefix="rs-filter"
										options={[{ label: 'All', value: '' }, ...filter.options]}
										defaultValue={{ label: 'All', value: '' }}
										onChange={(e) => handleFilterSelect(filter.name, e)}
									/>
								</div>
							) : null
						)}

						{filters?.find((filter) => filter?.name === 'date_range') && (
							<div style={{ marginBottom: 12, width: '100%', maxWidth: '100%', overflowX: 'auto' }}>
								<div style={{ width: '100%', maxWidth: '100%' }}>
									<DateRangePicker
										rangeColors={['#0066FF']}
										ranges={[
											{
												startDate: selectedValues?.startDate?.value ? moment(selectedValues?.startDate?.value).toDate() : null,
												endDate: selectedValues?.endDate?.value ? moment(selectedValues?.endDate?.value).toDate() : null,
												key: 'selection'
											}
										]}
										onChange={handleSelectDate}
										staticRanges={[
											{
												label: 'All',
												range: () => ({
													startDate: null,
													endDate: null
												}),
												isSelected: (e) => {
													return !selectedValues?.startDate?.value && !selectedValues?.endDate?.value;
												}
											},
											{
												label: 'Today',
												range: () => ({
													startDate: new Date(),
													endDate: new Date()
												}),
												isSelected: (e) => {
													return moment(e.startDate).isSame(moment(), 'day') && moment(e.endDate).isSame(moment(), 'day');
												}
											},
											{
												label: 'This Week',
												range: () => ({
													startDate: moment().startOf('week').toDate(),
													endDate: moment().endOf('week').toDate()
												}),
												isSelected: (e) => {
													return (
														moment(e.startDate).isSame(moment().startOf('week').toDate(), 'day') &&
														moment(e.endDate).isSame(moment().endOf('week').toDate(), 'day')
													);
												}
											},
											{
												label: 'This Month',
												range: () => ({
													startDate: moment().startOf('month').toDate(),
													endDate: moment().toDate()
												}),
												isSelected: (e) => {
													return (
														moment(e.startDate).isSame(moment().startOf('month').toDate(), 'day') &&
														moment(e.endDate).isSame(moment().toDate(), 'day')
													);
												}
											},
											{
												label: 'Last Month',
												range: () => ({
													startDate: moment().subtract(1, 'month').startOf('month').toDate(),
													endDate: moment().subtract(1, 'month').endOf('month').toDate()
												}),
												isSelected: (e) => {
													return (
														moment(e.startDate).isSame(moment().subtract(1, 'month').startOf('month').toDate(), 'day') &&
														moment(e.endDate).isSame(moment().subtract(1, 'month').endOf('month').toDate(), 'day')
													);
												}
											},
											{
												label: 'This Year',
												range: () => ({
													startDate: moment().startOf('year').toDate(),
													endDate: moment().toDate()
												}),
												isSelected: (e) => {
													return (
														moment(e.startDate).isSame(moment().startOf('year').toDate(), 'day') &&
														moment(e.endDate).isSame(moment().toDate(), 'day')
													);
												}
											},
											{
												label: 'Last Year',
												range: () => ({
													startDate: moment().subtract(1, 'year').startOf('year').toDate(),
													endDate: moment().subtract(1, 'year').endOf('year').toDate()
												}),
												isSelected: (e) => {
													return (
														moment(e.startDate).isSame(moment().subtract(1, 'year').startOf('year').toDate(), 'day') &&
														moment(e.endDate).isSame(moment().subtract(1, 'year').endOf('year').toDate(), 'day')
													);
												}
											}
										]}
										style={{ width: '100%', maxWidth: '100%' }}
									/>
								</div>
							</div>
						)}
					</div>

					<PermissionAllowed permissions={exportHistoryPerms}>
						<div
							style={{
								marginTop: 18,
								border: '1px solid #eee',
								borderRadius: 10,
								background: '#fafbfc',
								padding: 0,
							}}
						>
							<div
								style={{
									display: 'flex',
									justifyContent: 'space-between',
									alignItems: 'center',
									lineHeight: 1,
									padding: '10px 14px',
									cursor: 'pointer',
									background: '#f5f6fa'
								}}
								onClick={() => setShowHistory(!showHistory)}
							>
								<p style={{ fontWeight: 500, fontSize: 13, margin: 0 }}>History</p>
								<span style={{ fontSize: 18, display: 'flex', alignItems: 'center' }}>
									<IoIosArrowDropdown
										style={{
											transform: showHistory ? 'rotate(180deg)' : 'none',
											transition: 'transform 0.2s'
										}}
									/>
								</span>
							</div>
							<AnimatePresence initial={false}>
								{showHistory && (
									<motion.div
										initial={{ height: 0, opacity: 0 }}
										animate={{ height: 'auto', opacity: 1 }}
										exit={{ height: 0, opacity: 0 }}
										transition={{ duration: 0.25, ease: 'easeInOut' }}
										style={{
											overflow: 'hidden',
											background: '#fff',
											padding: '8px 14px 10px 14px'
										}}
									>
										{exportsHistory?.length > 0 ? (
											<div>
												{exportsHistory.map((item, index) => (
													<div
														key={index}
														style={{
															display: 'flex',
															justifyContent: 'space-between',
															fontSize: 13,
															padding: '6px 0',
															borderBottom: '1px solid #f0f0f0'
														}}
													>
														<span>{moment(item?.created_at).format(CommonDateOnlyFormat + ' hh:mm A')}</span>
														<span>
															{item?.user?.first_name} {item?.user?.last_name}
														</span>
													</div>
												))}
											</div>
										) : (
											<div style={{ color: '#aaa', fontSize: 13, padding: '8px 0' }}>No export history found.</div>
										)}
									</motion.div>
								)}
							</AnimatePresence>
						</div>
					</PermissionAllowed>
					<div
						className="btnarea"
						style={{
							position: 'sticky',
							bottom: 0,
							left: 0,
							width: '100%',
							background: '#fff',
							padding: '16px 0 12px 0',
							zIndex: 30,
							display: 'flex',
							gap: 10,
							justifyContent: 'center',
							marginTop: 'auto'
						}}
					>
						<button
							disabled={isLoading}
							onClick={() => {
								!isLoading && handleSubmit();
							}}
							className="btn btn-main"
						>
							{isLoading ? (
								<>
									<ImSpinner2 className="fa-spin" /> Downloading
								</>
							) : (
								<>
									<FaDownload /> Download
								</>
							)}
						</button>
						<button className="btn new-btn-error" onClick={disablepopup}>
							<FaTimes /> Close
						</button>
					</div>

				</div>
			</div>
		);
};

export default ExportListItemsModalMobile;
